module.exports = __webpack_public_path__ + "media/images/athletes/3409-ce8aee78a5dcc868c91db2b461d73fa4.png";